module.exports = __webpack_public_path__ + "static/media/YB5M01_2.dec3dd3c.jpg";